module.exports = __webpack_public_path__ + "img/lactose.fb750c4b.png";